<div *ngIf="t_dashboard_loader == true" style="height: 80vh">
    <div  style="height: 300px; display: flex; justify-content: center; align-items: center; flex-direction: column;" class="loaderWrapper">
        <img src="assets/images/loading.gif" class="faLoader" width="50" height="50" />
        <p>{{loadingMsg}}</p>
    </div>
    
</div>
<div *ngIf="t_dashboard_loader == false && onBoardingCheck == false" class="tenant_side_bar" id="side_bar">
    <p class="file-head" [ngClass]="dashboardScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant', 'dashboard']" data-dismiss="modal" (click)="getParameter('dashboard')"> <fa-icon class="option_icon" [icon]="faShareAlt"></fa-icon><span class="option_name">Dashboard</span></p>
    <p class="file-head" [ngClass]="documentScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'document']" data-dismiss="modal" (click)="getParameter('document')"> <fa-icon class="option_icon" [icon]="faFile"></fa-icon><span class="option_name">Documents</span></p>
    <!-- <p class="file-head" [ngClass]="agreementScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'agreement']" data-dismiss="modal"(click)="getParameter('agreement')"> <fa-icon class="option_icon" [icon]="faFileSign"></fa-icon><span class="option_name">Agreement</span></p> -->
    <p class="file-head" [ngClass]="serviceScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'service']" data-dismiss="modal"(click)="getParameter('service')"> <fa-icon class="option_icon" [icon]="faTools"></fa-icon><span class="option_name"> Requests</span></p>
    <p class="file-head" [ngClass]="referalScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'referal']" data-dismiss="modal"(click)="getParameter('referal')"> <fa-icon class="option_icon" [icon]="faHandsHelping"></fa-icon><span class="option_name">References</span></p>
    <p class="file-head" [ngClass]="offerScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'offers']" data-dismiss="modal"(click)="getParameter('offers')"> <fa-icon class="option_icon" [icon]="faCerti"></fa-icon><span class="option_name">Offers</span></p>
</div>
<div class="tenant_side_bar_small">
<div *ngIf="t_dashboard_loader == false && onBoardingCheck == false" class="tenant_options"  data-direction='left' data-toggle="modal" data-target="#tenantActionModal" id="sidebar_toggle">
    <fa-icon [icon]="faRight" class="tenant_options_icon"></fa-icon>
</div>
<div class="modal left fade" id="tenantActionModal" tabindex="-1" aria-labelledby="tenantActionModalLabel" aria-hidden="true">
    <div class="optionModelDialog modal-dialog modal-lg ">
        <div class="modal-content optionModelContent">
          <div class="modal-body optionModelBody">
            <p class="file-head-small" [ngClass]="dashboardScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant', 'dashboard']" data-dismiss="modal" (click)="getParameter('dashboard')"> Dashboard<span class="option_icon_wrapper"><fa-icon class="option_icon_small" [icon]="faShareAlt"></fa-icon> </span></p>
            <p class="file-head-small" [ngClass]="documentScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'document']" data-dismiss="modal" (click)="getParameter('document')"> Documents<span class="option_icon_wrapper"><fa-icon class="option_icon_small" [icon]="faFile"></fa-icon> </span></p>
            <!-- <p class="file-head-small" [ngClass]="agreementScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'agreement']" data-dismiss="modal"(click)="getParameter('agreement')"> Agreements<span class="option_icon_wrapper"><fa-icon class="option_icon_small" [icon]="faFileSign"></fa-icon> </span></p> -->
            <p class="file-head-small" [ngClass]="serviceScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'service']" data-dismiss="modal"(click)="getParameter('service')"> Service Requests<span class="option_icon_wrapper"><fa-icon class="option_icon_small" [icon]="faTools"></fa-icon> </span></p>
            <p class="file-head-small" [ngClass]="referalScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'referal']" data-dismiss="modal"(click)="getParameter('referal')"> References<span class="option_icon_wrapper"><fa-icon class="option_icon_small" [icon]="faHandsHelping"></fa-icon> </span></p>
            <p class="file-head-small" [ngClass]="offerScreen == true ? 'activeScreen' : '' " [routerLink]="['/profile/tenant',  'offers']" data-dismiss="modal"(click)="getParameter('offers')"> Offers<span class="option_icon_wrapper"><fa-icon class="option_icon_small" [icon]="faCerti"></fa-icon> </span></p>
            <div class="tenant_options_close" data-dismiss="modal">
                <fa-icon [icon]="faLeft" class="tenant_options_icon_close" ></fa-icon>
            </div>
          </div>
        </div>
      </div>
</div>
</div>
<div *ngIf="t_dashboard_loader == false" class="dashboard_body" id="dashboard_body">
    
    <!-- <div class="page-links" >
        <div class="wrapper" *ngIf="onBoardingCheck == false">
            <a class="file-head col-md-2" [routerLink]="['/profile/tenant', 'profile/tenant']" (click)="getParameter('dashboard')"> Dashboard </a>
            <a class="file-head col-md-2" [routerLink]="['/profile/tenant',  'document']" (click)="getParameter('document')"> Document </a>
            <a class="file-head col-md-2" [routerLink]="['/profile/tenant',  'agreement']" (click)="getParameter('agreement')"> Agreement </a>
            <a class="file-head col-md-2" [routerLink]="['/profile/tenant',  'service']" (click)="getParameter('service')"> Service </a>
            <a class="file-head col-md-2" [routerLink]="['/profile/tenant',  'referal']" (click)="getParameter('referal')"> Referal </a>
            <a class="file-head col-md-2" [routerLink]="['/profile/tenant',  'offers']" (click)="getParameter('offers')"> Offers </a>     
        </div> 
    </div>   -->
<!--------------------------------------- Template for dashboard component start ---------------------------------->
    <div class="container-fluid" *ngIf="dashboardScreen == true" >
        <div class="container">
                <div *ngIf="tenantPropCheck == 1">
                    <h2 *ngIf="onBoardingCheck == true && t_dashboard_loader == false" class="pt-4 greetings"> Hey <span style="text-transform: capitalize;"> {{ tenantName }} </span> ! Please move forward with your Onboarding Process </h2>
                </div>
                <h2 *ngIf="onBoardingCheck == false" class="greetings" > Hey <span style="text-transform: capitalize;"> {{ tenantName }} </span> ! Let's see how you are doing at YourOwnROOM </h2>
            <div class="row" style="margin: auto;"> 
                <div class="col-md-9 profile_wrapper">
                    <div class="row" style="padding: 10px 0px;" >
                        <div class="col-12 col-md-4 mt-4 mt-md-0 profile">
                            <div *ngIf="pro_img != null">
                                <div class="col-12 profile-img">
                                    <img src="{{ pro_img }}" alt="YourOwnROOM Tenant Profile Picture">
                                </div>
                            </div>
                            <div *ngIf="pro_img == null">
                                <div class="col-12 profile-img">
                                    <img src="assets/images/profile.png" alt="YourOwnROOM Tenant Profile Picture">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8 profile-detail text-left">
                            <div class="row" *ngIf="tenantPropCheck == 1" style="display: flex; justify-content: space-between;">
                                <div class="col-md-6">
                                    <h3> Virtual Account Number:</h3>
                                </div>
                                <div  class="col-md-5 font-weight-bolder">
                                    <p style="font-size: 16px;">{{ tenantProps[0].virtual_number }} </p>
                                </div> 
                            </div>
                            <br>
                            <div class="user_detail">
                                <p style="font-size: 14px;">{{ user.phone }} </p>
                                <p style="font-size: 14px;">{{ user.email }}</p>
                                <p style="font-size: 14px; margin-top: 30px;" *ngIf="tenantPropCheck == 1">{{ tenantProps[0].property.flat_no }}, {{ tenantProps[0].property.name }}, {{ tenantProps[0].property.addressl1 }} </p>
                            </div>
                        </div>    
                    </div>
                </div>
                <div class="col-md-3"  style="padding: 0;" *ngIf="tenantPropCheck == 1">
                    <div class="col-md-12 anchor-box" *ngIf="onBoardingCheck;then incompleteOnBoarding; else completeOnBoarding"></div>
                </div>
                <!-- <div class="col-md-3" *ngIf="tenantPropCheck != 1">
                    <h2> You are not yet linked to any of our property! </h2>
                </div> -->                
                    <ng-template #incompleteOnBoarding >
                        <div class="col-md-12 anchor-box" >
                            <button class="btn col-sm-12 yellDiv" [ngStyle]="{'cursor' : isTokenDisabled ? 'not-allowed' : 'pointer'}" [disabled]="isTokenDisabled" data-toggle="modal" data-target="#payTokenModal" (click)="onTokenBtnClick('rent',tenantProps[0].id)"> Pay Token</button>
                            <!-- <button class="btn col-sm-12 yellDiv" [ngStyle]="{'cursor' : isRoomAllocDisabled ? 'not-allowed' : 'pointer'}" [disabled]="isRoomAllocDisabled" [routerLink]="['/roomalloc']"  >Room Allocation </button> -->
                            <button class="btn col-sm-12 yellDiv" [ngStyle]="{'cursor' : isDocumentDisabled ? 'not-allowed' : 'pointer'}" [disabled]="isDocumentDisabled" [routerLink]="['/uploaddocsandrefs']"  > Upload Documents </button>
                            <button class="btn col-sm-12 yellDiv" [ngStyle]="{'cursor' : isPayDepositDisabled ? 'not-allowed' : 'pointer'}" [disabled]="isPayDepositDisabled" data-toggle="modal" data-target="#depoContentModal" >Pay Deposit </button>
                            <button class="btn col-sm-12 yellDiv" [ngStyle]="{'cursor' : isGenAgreemDisabled ? 'not-allowed' : 'pointer'}" [disabled]="isGenAgreemDisabled"  data-toggle="modal" data-target="#genAgreeModal" >Generate Agreement </button>    
                        </div>
                    </ng-template>  
                <ng-template #completeOnBoarding>
                    <div class="col-md-12 anchor-box">
                        <a class="btn col-sm-12 yellDiv" data-toggle="modal" data-target="#rentPaymentModal" (click)="showRentPaymentPopup('rent', tenantProps[0].id)"> Pay Rent</a>
                        <!-- <a class="btn col-sm-12 yellDiv" data-toggle="modal" data-target="#refModal"> Refer a Friend</a> -->
                        <!-- <a class="btn col-sm-12 yellDiv" data-toggle="modal" data-target="#agreeModal"> Renew Agreement</a> -->
                        <a class="btn col-sm-12 yellDiv" data-toggle="modal" data-target="#exitModal" (click)="initiateExitProcess(tenantProps[0].id,tenantProps[0].property_id)">Initiate Exit </a>
                    </div>
                </ng-template>
            </div> 
        </div>
        <div class="container" *ngIf="!onBoardingCheck" style="margin-top: 60px;">
            <div class="row charts">
                <div class="col-md-6 receipt-chart">
                    <div class="shadow p-3 mb-5 mt-5" style="border-radius: 5px;">
                        <div class="deposit_rec">
                            <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
                                <h3 style="margin: 0;"> Deposit</h3>
                                <fa-icon [icon]="faReceipt" style="font-size: 20px; color: #339af0;"></fa-icon>
                            </div>
                        </div>
                        <hr>
                        <div class="view_rec">
                            <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
                                <h4 style="font-weight: 400; margin: 0;"> Deposit Paid: <span style="font-weight: 500; font-size: 18px;">  &#x20B9; {{ tenantProps[0].deposite }} </span>  </h4>
                                <!-- <a class="text-center view_receipt" data-toggle="modal" data-target="#depositRecModal" style="cursor: pointer;">View Receipt </a> -->
                            </div>
                        </div>
                    </div>
                    <div class="shadow p-3 mb-5 bg-yellow " style="border-radius: 5px;">
                        <div class="deposit_rec">
                            <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
                                <h3 style="margin: 0;"> Rent Receipts</h3>
                                <fa-icon [icon]="faReceipt" style="font-size: 20px; color: #339af0;"></fa-icon>
                            </div>
                        </div>
                        <hr>
                        <div class="view_rec">
                            <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
                                <h4 style="font-weight: 400; margin: 0;"> Monthly Rent: <span style="font-weight: 500; font-size: 18px;">  &#x20B9; {{ tenantProps[0].rent }} </span>  </h4>
                                <a class="text-center view_receipt" data-toggle="modal" data-target="#rentRecModal" style="cursor: pointer;">View Receipts </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 progress-chart mb-5">
                    <div *ngIf="showSpinner">
                        <div class="text-center" style="font-family: 'Montserrat', sans-serif;">
                            <circle-progress
                                [percent] ="percentage" 
                                [title] = "no_of_month"
                                [radius]="150"
                                [outerStrokeWidth]="20"
                                [outerStrokeColor]="'#F9E316'"
                                [animation]="true">
                            </circle-progress>
                        </div>
                        <div class="row text-center">
                            <div class="col-6 border-right">
                                <span class="small text-gray">Start Date</span> <div class="h6" style="font-weight: 600;" ><p> {{ tenantProps[0].occupfrom }} </p> </div>
                            </div>
                            <div class="col-6">
                                <span class="small text-gray">End Date</span> <div class="h6" style="font-weight: 600;"><p> {{ tenantProps[0].occupto }}</p> </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="displayDaysRem">
                        <div class="shadow mt-5 p-3 tab_display_days" style="border-radius: 5px;">
                            <div style="display: flex; justify-content: space-between; padding: 0px 15px; ">
                                <h3 class="days_left"> Days Remaining: </h3>
                                <h3 class="days_left"> {{ daysLeft }} days   </h3>
                            </div>
                            <div style="display: flex; justify-content: space-between; padding: 20px 15px 5px 15px">
                                <h3 class="days_left"> Tenure End Date: </h3>
                                <h3 class="days_left"> {{ tenantProps[0].occupto }}  </h3>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    <!---------------------------- Modals for Dashboard starts here ------------ d-none d-md-block d-lg-block d-xl-block------------------------------->
    <div class="modal fade" id="rentPaymentModal" tabindex="-1" aria-labelledby="rentPaymentModalLabel" aria-hidden="true" *ngIf="onBoardingCheck == false">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        
                            <div *ngIf="rentAmount > 0 && rentDataLoader == 1">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal"></fa-icon>
                                </div>
                                <div class="col-md-12">
                                    <h3 class="text-center">  Total amount due :  <span style="font-weight: 600;"><em>&nbsp; &#x20B9;  {{ rentAmount }}</em> </span> </h3>
                                    <hr/>
                                    <div class="text-center">
                                        <p>Scan & Pay through UPI (Zero Convenience Fee)</p>
                                        <!-- <qr-code value="qrcodeval" size="300" errorCorrectionLevel="M"></qr-code> -->
                                        <ngx-qrcode 
                                            [elementType]="url" 
                                            [value] = "qrcodeval"
                                            errorCorrectionLevel = "L">
                                        </ngx-qrcode>
                                    </div>
                                    <div class="text-left" style="margin-bottom:30px; margin-top:10px;display: flex; justify-content: center;">
                                        <div>
                                            <h4 style="text-align: left;"> Your Virtual Account Number for NEFT / IMPS / Bank Transfer : <span style="font-weight: 600;"><em>{{ tenantProps[0].virtual_number }} </em></span> </h4>
                                            <h4 style="text-align: left;"> IFSC : <span style="font-weight: 500;"> <em>DBSS0IN0811</em> </span> </h4>
                                            
                                            <div>
                                                <p style="font-size: 10px;">
                                                    <input class="paym_gateway gateway_select" name="rent_pay" type="radio" value="razor" [ngModel]="rent_payment" (change)="changegateway($event)">&nbsp;
                                                    <img src="https://razorpay.com/images/logo.png"  style="height: 29px;background-color: #20296a; padding: 3px;">
                                                </p>
                                                <p style="font-size: 12px; text-align: left;"> (1.75% + 18%GST Applicable (Convenience fee))</p>
                                                <p style="font-size: 10px;">
                                                    <!-- [ngModel]="rent_payment" (change)="changegateway($event)" (Add this when paytm issue is resolved and remove the grayscale from style tag of paytm image.) -->
                                                    <!-- <input class="paym_gateway gateway_select" name="rent_pay" type="radio" value="paytm" >&nbsp; -->
                                                    <!-- <img src="assets/images/paytm.png" style="height: 29px;background-color: white;padding: 3px; filter: grayscale(1)"> -->
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-center" style="padding: 10px 0px;">
                                        <a class="btn btn-success " id="pay_now" style="width:50%; margin: 5px 50px;" (click)="initPayment()">Pay Now</a>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="(rentAmount == 0 || rentAmount == undefined) && rentDataLoader == 1 " style="padding: 70px;">
                                <p style="font-size: 18px; margin: 0;">You have no outstanding dues.</p>
                            </div>
                            <div *ngIf="rentDataLoader == 0">
                                <div  style="height: 300px; display: flex; justify-content: center; align-items: center; flex-direction: column;" class="loaderWrapper">
                                    <img src="assets/images/loading.gif" class="faLoader" width="50" height="50" />
                                    <p>{{loadingMsg}}</p>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="payTokenModal" tabindex="-1" aria-labelledby="payTokenModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Pay Token </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right" style="padding: 10px 20px;">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="col-md-12 scroll pt-4" style="height: 400px;">
                                    <div [innerHTML]="kycAcknowdata.consent" class="text-justify" style="font-size: 14px;"></div>
                                    <div id="content" class="text-justify" style="font-size: 16px;"> </div>
                                </div>
                                <div class="col-md-12 p-3">
                                    <input type="checkbox" (click)="showHideSubmit($event.target.checked)" [(ngModel)]="isChecked" style="margin-top: 20px">&nbsp; <b> Accept Terms & Conditions For Payment. </b> <br>
                                    <div style="display: flex; justify-content: center;"> 
                                        <button id="agreePolicy" *ngIf="agreePolicy == 0" data-dismiss="modal" data-toggle="modal" data-target="#tokenPaymentModal" (click)="savePolicy(agreepayTyp,agreepayTypId)" class="btn btn-success mt-2" style="width:60%">Submit</button>
                                        <button id="agreePolicy" disabled *ngIf="agreePolicy == 1" class="btn btn-danger mt-2">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="tokenPaymentModal" tabindex="-1" aria-labelledby="tokenPaymentModalLabel" aria-hidden="true" *ngIf="onBoardingCheck == true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Pay Token </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="col-md-12" style="margin-bottom:15px; margin-top:20px;">
                                    <p class="text-center"> <em> Proceed For a Payment of<br> </em> <span style="font-size: 16px; font-weight: 500;"> &#x20B9; {{ tokenMoney }} </span></p>
                                    <hr/> 
                                    <div class="text-center">
                                        <p>Scan & Pay through UPI (Zero Convenience Fee)</p>
                                        <!-- <qr-code value="qrcodeval" size="300" errorCorrectionLevel="M"></qr-code> -->
                                        <ngx-qrcode 
                                            [elementType]="url" 
                                            [value] = "qrcodeval"
                                            errorCorrectionLevel = "L">
                                        </ngx-qrcode>
                                    </div>
                                    <div class="text-left" style="margin-bottom:30px; margin-top:10px; display: flex; justify-content: center;">
                                        <div>
                                            <h5 style="text-align: left;"> Bank:  &nbsp;  <span style="font-weight: 500;"> DBS BANK </span> </h5>
                                            <h5 style="text-align: left;"> Virtual Account Number:  <span style="font-weight: 500;"> {{ tenantProps[0].virtual_number }} </span> </h5>
                                            <h5 style="text-align: left;"> IFSC:  <span style="font-weight: 500;"> ICICI0003 </span> </h5>
                                            
                                            <div>
                                                <p>
                                                    <input type="radio" value="razor" name="token_pay" [ngModel]="token_payment" (change)="changegateway($event)" >&nbsp;
                                                    <img src="https://razorpay.com/images/logo.png" width="" style="height: 29px;background-color: #20296a;padding: 3px;">
                                                </p>
                                                <p style="font-size: 12px; text-align: left;"> (1.75% + 18%GST Applicable (Convenience fee))</p>
                                                <p>
                                                    <!-- [ngModel]="token_payment" (change)="changegateway($event)" (Add this when paytm issue is resolved nad remove the grayscale from style tag from paytm image.)-->
                                                    <!-- <input type="radio" value="paytm" name="token_pay" > &nbsp; -->
                                                    <!-- <img src="assets/images/paytm.png" width="" style="height: 29px;background-color: white;padding: 3px; filter: grayscale(1);"> -->
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <a class="btn btn-success" id="pay_now" style="width:60%; margin: 5px 50px;" (click)="initPayment()">Pay Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="agreeModal" tabindex="-1" aria-labelledby="agreeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Renew Agreement </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="p-4">
                                    <h1 class="text-center" style="font-weight: 500;"> Please select to Renew Agreement</h1>
                                    <hr>
                                    <select class="form-control form_sel">
                                        <option value="months" disabled> Months </option>
                                        <option *ngFor="let x of renewAgreementSel" [ngValue]="x.id">{{x.text}} </option>
                                    </select>  
                                    <div style="display: flex; justify-content: center; margin: 20px 0px;"> 
                                        <button class="btn btn-primary mt-3" data-dismiss="modal" style="background-color: #F9E316; border: none; float: right; color: black; font-weight: 500;" > Renew </button>
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="refModal" tabindex="-1" aria-labelledby="refModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Past Referals </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="ref_friend" style="width: 100%;">
                                    <table style="width: 100%;">
                                        <tr>
                                            <th>Name </th>
                                            <th>Phone </th>
                                            <th>Email </th>
                                        </tr>
                                        <tr>
                                            <td> Meena Sharma</td>
                                            <td> 8470998466</td>
                                            <td> meenayor21@gmail.com</td>
                                        </tr>
                                        <tr>
                                            <td> Nisha Jha</td>
                                            <td> 8596225102</td>
                                            <td> nishayor21@gmail.com</td>
                                        </tr>
                                        <tr>
                                            <td> Rishab Raj</td>
                                            <td> 9930689665</td>
                                            <td> rishabyor21@gmail.com</td>
                                        </tr>
                                    </table>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="exitModal" tabindex="-1" aria-labelledby="exitModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Initiate Exit </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="p-2">
                                    <h1 class="text-center" style="font-weight: 500;"> Are you sure? </h1>
                                    <hr>
                                    <form role="form">
                                        <div class="form-group col-md-12">
                                            <input class="col-md-12 form-control"  [min]="minExitDate" name="exitdate" 
                                            [ngModel]="userexit.exitdate" (ngModelChange)="changeExitDate($event)" type="text" onfocus="(this.type='date')" id="date" >
                                        </div>
                                        <div class="form-group col-md-12">
                                            <textarea name="exitreason" class="form-control col-md-12 mt-2 mb-2" rows="5" placeholder="Reason for Exit"[ngModel]="userexit.reason" (ngModelChange)="changeExitReason($event)" required></textarea>
                                        </div>
                                        <div class="form-group col-md-12" style="justify-content: center; display: flex; margin: 20px 0px;">
                                            <a class="btn btn-primary" (click)="initExit()" data-dismiss="modal" style="background-color: #F9E316; border: none; color: black;font-weight: 500;" >Submit</a>    
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="rentRecModal" tabindex="-1" aria-labelledby="rentRecModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Rent Receipts </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="scroll mt-3 mb-3" *ngIf="rentRecps.length > 0">        
                                    <div class="shadow m-3" *ngFor="let rec of rentRecps">
                                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px;">
                                            <p> {{ rec.dispMonth }} </p>
                                            <p> Status: Paid</p>
                                        </div>
                                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px;">
                                            <p style="font-weight: 500;">  &#x20B9; {{ rec.amount }}  </p>
                                            <p *ngIf="rec.status==2" class="tenant_rent_link" ><span style="color: #339af0"><fa-icon [icon]="faFileAlt"></fa-icon></span><a  style="text-decoration: none !important;" href="{{ ('https://api.yourownroom.com/api/w/v1/user/receipt/' + rec.id + '/' + user.id + '/1')  }}" >  Download</a> </p>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="rentRecps.length == 0">
                                    <div style="padding: 40px 0px; text-align: center;">
                                        <h1> No Rent Receipts to show!</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="depositRecModal" tabindex="-1" aria-labelledby="depositRecModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Deposit Receipt </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <div class="p-3">
                                        <p> Name: <span style="text-transform: capitalize; font-weight: 500;"> {{ user.name }}   </span> </p>
                                        <p> Phone: <span style="font-weight: 500;"> {{ user.phone }}  </span> </p>
                                        <p class="deposit_popup_email"> Email: <span style="font-weight: 500;"> {{ user.email }} </span> </p>
                                        <p> Virtual Account Number : <span style="font-weight: 500;"> {{ tenantProps[0].virtual_number }} </span> </p>
                                        <!-- <p> Amount: <span style="font-weight: 500;"> &#x20B9; {{ depoRecps.amount }}  </span> </p> -->
                                        <p> Date: <span style="font-weight: 500;"> {{ depositDate}} </span></p>
                                        <p> Status: <span style="font-weight: 500;"> Credited </span> </p>
                                    </div>
                                </div>
                                <!-- <div class="p-3" style="display: flex; justify-content: center;">
                                    <button class="btn btn-success"> Download </button>
                                </div>  -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="depoContentModal" tabindex="-1" aria-labelledby="depoContentModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Pay Deposit </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div>        
                                    <div class="p-3">
                                        <div style="display: flex; justify-content: center;">
                                            <div style="width: 80%;">
                                                <p class="mb-3"> Please contact our Sales Team for your deposit payment</p>
                                                <p> You can contact us at <b> +91-9148633679</b> or email to us at <a href="mailto:care@yourownroom.com">care@yourownroom.com </a> </p>
                                            </div>
                                        </div>                      
                                        <div style="display: flex; justify-content: center;">
                                            <a class="btn col-sm-6 yellDiv" style="padding: 10px 15px;" (click)="mailContact()" > Contact </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="genAgreeModal" tabindex="-1" aria-labelledby="genAgreeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Generate Agreement </p>
                                </div>
                            </div>
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="p-3">
                                    <div style="display: flex; justify-content: center;">
                                        <h2 class="mb-3" style="width: 80%;"> Your Agreement is being generated </h2>
                                    </div>
                                    <div style="display: flex; justify-content: center;">
                                        <a class="btn col-sm-6 yellDiv" style="padding: 10px 15px;" (click)="genAgree()" > Accept </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-------------------------------- Modals ends here ------------------------------------->
    </div>
<!------------------------------------------------------- Dashboard component ends here ---------------------------------------->
    <!--------------------------------------------- Agreement Screen Template start ----------------------------------->
    <div class="container-fluid" *ngIf="agreementScreen == true">
        <div class="container">
            <div class="mb-5">
                <h2 class="greetings"> Hey <span style="text-transform: capitalize;"> {{ tenantName }} </span> ! Let's see how you are doing at YourOwnROOM </h2>
            </div>
            <h3 style="font-size: 20px; font-weight: 500;"> Your Agreement </h3>
            <div class="row agreement_lg">
                <div class="col-5"> 
                    <div *ngIf="showSpinner">
                        <div class="text-center" style="font-family: 'Montserrat', sans-serif;">
                            <circle-progress
                                    [percent] ="percentage" 
                                    [title] = "no_of_month"
                                    [radius]="150"
                                    [outerStrokeWidth]="20"
                                    [outerStrokeColor]="'#F9E316'"
                                    [animation]="true">
                            </circle-progress>
                        </div>
                        <div class="row text-center mt-1">
                            <div class="col-6 border-right">
                                <span class="small text-gray">START DATE</span> <div class="h6" style="font-weight: 600;" ><p> {{ tenantProps[0].occupfrom }} </p> </div>
                            </div>
                            <div class="col-6">
                                <span class="small text-gray">END DATE</span> <div class="h6" style="font-weight: 600;" ><p> {{ tenantProps[0].occupto }} </p> </div>
                            </div>
                        </div>
                    </div> 
                    <div *ngIf="displayDaysRem">
                        <div class="tab_display_days p-3 mt-3">
                            <div class="tab_days_left">
                                <h3 style="font-weight: 500;"> Days Remaining: </h3>
                                <h3 style="font-weight: 500;">  {{ daysLeft }} days   </h3>
                            </div>
                            <div class="tab_tenure_end mb-2" style="display: flex; justify-content: space-between; padding-top: 30px;">
                                <h3 style="font-weight: 500;"> Tenure End Date: </h3>
                                <h3 style="font-weight: 500;">  {{ tenantProps[0].occupto }}  </h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class=" mt-3 p-4 shadow" style="padding: 30px; cursor: pointer;display: flex;justify-content: center;" (click)="showRentAggr()">
                        <h3 style="font-weight: 500;"> View Rent Agreement </h3>
                    </div>
                </div>
            </div>
            <div class="agreement_sm">
                <div class="col-12">
                    <div *ngIf="showSpinner">
                        <div class="text-center">
                            <circle-progress
                                [percent] ="percentage" 
                                [title] = "no_of_month"
                                [radius]="150"
                                [outerStrokeWidth]="20"
                                [outerStrokeColor]="'#F9E316'"
                                [animation]="true">
                            </circle-progress>
                        </div>
                        <div class="row text-center mt-1">
                            <div class="col-6 border-right">
                                <span class="small text-gray">START DATE</span> <div class="h6 font-weight-bold" > {{ tenantProps[0].occupfrom }} </div>
                            </div>
                            <div class="col-6">
                                <span class="small text-gray">END DATE</span> <div class="h6 font-weight-bold" > {{ tenantProps[0].occupto }} </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="displayDaysRem">
                        <div class="tab_display_days p-3 mt-3">
                            <div class="tab_days_left">
                                <h3  style="font-weight: 500;"> Days Remaining: </h3>
                                <h3 style="font-weight: 500;"> {{ daysLeft }} days   </h3>
                            </div>
                            <div class="tab_tenure_end mb-2" style="display: flex; justify-content: space-between; padding-top: 30px;">
                                <h3 style="font-weight: 500;"> Tenure End Date: </h3>
                                <h3 style="font-weight: 500;"> {{ tenantProps[0].occupto }} </h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class=" mt-3 p-4 shadow" style="padding: 30px; cursor: pointer;display: flex;justify-content: center;" (click)="showRentAggr()">
                        <h3 style="font-weight: 500;"> View Rent Agreement </h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-------------------------------------------- Agreement Screen ends here ------------------------------------------>
    <!--------------------------------------------- Service Screen start -------------------------------------------------->
    <div class="container-fluid" *ngIf="serviceScreen == true">
        <div class="container">
            <div class="mb-4">
                <h2 class="greetings">Hey <span style="text-transform: capitalize;"> {{ tenantName }} </span> ! Anything troubling you at YourOwnROOM? </h2>
                <h2 class="greetings"> Raise a request for any of the services below that you need help with. </h2>
            </div> 
        </div>
        <div class="container">
            <div class="row" style="display: flex; justify-content: space-between;">
                <div class="col-md-5">
                    <h4 style="font-size: 18px; font-weight: 500;"> Your Own Requests </h4>
                </div>
                <div class="col-md-5">
                    <button (click)="newSReqPopup(this.tenantProps[0].property_id,this.tenantProps[0].room_id)" data-toggle="modal" data-target="#sRequestModal" class="btn raise_service" style="float: right;">Make Service Request </button>
                </div>
            </div>
<!--------------------------------- Progress bar for large screen begin here ------------------------->
            <div class="row mt-4 circular_progress_large">
                <div class="col-md-4 service-progress-chart">
                    <div class="bg-white rounded-lg p-3">
                        <div class="progress mx-auto">
                            <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                <div class="h4 " style="text-align: center; font-weight:600 "> <p> {{ sRequestTotal }} </p>  </div> &nbsp;
                                <div class="p " style="text-align: center; font-weight:600 "><p> Raised </p> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 service-progress-chart">
                    <div class="bg-white rounded-lg p-3">
                        <div class="progress mx-auto">
                            <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                <div class="h4 " style="text-align: center; font-weight:600 "><p> {{ srPending }} </p>  </div> &nbsp;
                                <div class="p " style="text-align: center; font-weight:600 "> <p> Pending </p> </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="col-md-4 service-progress-chart">
                    <div class="bg-white rounded-lg p-3">
                        <div class="progress mx-auto">
                            <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                <div class="h4 " style="text-align: center; font-weight:600 "><p> {{ srClosed }} </p>  </div> &nbsp;
                                <div class="p " style="text-align: center; font-weight:600 "><p> Closed</p> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
<!---------------------------- Progress bar for large screen ends here ------------------------------------>
<!------------------------------- Progress bar for small screen begin here -------------------------------->
            <div class="row mt-4 circular_progress_small">
                <div class="col-4 service-progress-chart">
                    <div class="bg-white rounded-lg p-3">
                        <div class="progress progress-sm mx-auto">
                            <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                <div class="h6" style="text-align: center; font-weight:600 "><p> {{ sRequestTotal }} </p>  </div> &nbsp;
                                <div class="p" style="text-align: center; font-weight:600 "> <p> Raised </p> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4  service-progress-chart">
                    <div class="bg-white rounded-lg p-3">
                        <div class="progress progress-sm mx-auto">
                            <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                <div class="h6" style="text-align: center; font-weight:600 "><p> {{ srPending }}</p>  </div> &nbsp;
                                <div class="p" style="text-align: center; font-weight:600 "> <p> Pending </p> </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="col-4  service-progress-chart">
                    <div class="bg-white rounded-lg p-3">
                        <div class="progress progress-sm mx-auto">
                            <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                <div class="h6" style="text-align: center; font-weight:600 "><p> {{ srClosed }} </p> </div> &nbsp;
                                <div class="p" style="text-align: center; font-weight:600 "><p> Closed </p> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
<!------------------------------- Progress bar for small screen ends here ------------------------------>
        </div>
        <div class="container" *ngIf="sRequestTotal == 0">
            <div style="display: flex; justify-content: center;">
                <div class="shadow" style="padding: 20px; margin: 20px 0px;">
                    <h2 class="text-center p-2"> No Service Request raised till date </h2>
                </div>
            </div>
        </div>
        <div class="container" *ngIf="sRequestTotal > 0"> 
            <div class="row"  style="display: flex; justify-content: space-between;">
                <div class="col-md-5 shadow mt-4 p-4 serviceStatus" *ngFor="let x of uniqueServiceRequest" >
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <h3 style="font-weight: 500;"> {{x == 1 ? "Keys" : x == 12 ?"Plumbing" : x == 17 ?"Furniture" : x == 47 ?"Cleaning" : x == 49 ?"Electrical" : x == 51 ?"Carpentry" : x == 60 ?"Others" : " "}} </h3>
                        <fa-icon [icon]="x == 1 ? faKey : x == 12 ? faFaucet : x == 17 ? faCouch : x == 47 ? faBroom : x == 49 ? faPlug : x == 51 ? faTools : faCogs" class="fa-2x" style="color: lightblue"></fa-icon>
                    </div> 
                    <div class="mt-2" style="display: flex; justify-content: space-between;">
                        <p> Total Request Raised</p>
                        <p class="text-right"> {{x == 1 ? srKeys : x == 12 ?srPlumbing : x == 17 ?srFurnishing : x == 47 ?srCleaning : x == 49 ?srElectrical : x == 51 ?srCarpentry : x == 60 ?srOthers : " "}} </p>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <p> Pending Request</p>
                        <p> {{x == 1 ? srKeysPend : x == 12 ?srPendingPlumbing : x == 17 ?srPendingFurnishing : x == 47 ?srCleaningPending : x == 49 ?srElectricalPend : x == 51 ?srPendingCarpentry : x == 60 ?srOthersPending : " "}}  </p>
                    </div>
                    <p class="pt-2" style="font-size: 16px; cursor: pointer; font-weight: 500;" data-toggle="modal" data-target="#serviceReqModal" (click)="serviceRequestDetail(x)" > View Requests</p>
                </div>
            </div> 
        </div>
        <div class="modal fade" id="serviceReqModal" tabindex="-1" aria-labelledby="serviceReqModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                <div class="modal-body">
                    <div style="display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                        <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <h2 class="modal-title"> {{service_id == 1 ? "Keys" : service_id == 12 ?"Plumbing" : service_id == 17 ?"Furniture" : service_id == 47 ?"Cleaning" : service_id == 49 ?"Electrical" : service_id == 51 ?"Carpentry" : service_id == 60 ?"Others" : " "}}  </h2>
                        <fa-icon  [icon]="service_id == 1 ? faKey : service_id == 12 ? faFaucet : service_id == 17 ? faCouch : service_id == 47 ? faBroom : service_id == 49 ? faPlug : service_id == 51 ? faTools : faCogs" class="fa-2x" style="color: lightblue"></fa-icon>
                    </div>
                    <div *ngFor="let sr of srDetail" class="sreqs pl-2 pr-2" 
                            [ngStyle]=
                                "sr.status == 1 ? {'background-color' : '#FEF7EA' , 'border': '1px solid #F9E316'} : 
                                sr.status == 2 ? {'background-color' : '#E5EFFA' , 'border': '1px solid #339af0'} :  
                                {'background-color' : '#EBF7EE' , 'border': '1px solid #4BB543'}">
                            <div class="row justify-content-between">
                                <p class="col-6 col-md-4" style="font-weight: 500;">
                                    <fa-icon [ngClass]="sr.status == 2 ? 'icon_glow' : ''" [icon]="faDotCircle" [ngStyle]="{'color' : sr.status == 1 ? '#F9E316' : sr.status == 2 ? '#339af0' : '#4BB543'}" ></fa-icon>
                                    #YOR_{{sr.id}}
                                </p>
                                <p style="text-align: end; "class="col-6 col-md-4">    
                                    {{sr.status == 1 ? 'Open' : sr.status == 2 ? 'In-Progress' : 'Closed'}} 
                                </p>
                            </div>
                            <p>{{sr.detail }}</p>
                            <div class="row justify-content-between">
                                <div class="col-12 col-md-4">
                                    <p>Raised on: <span style="font-weight: 500;">{{sr.created_at}}</span></p>
                                </div>
                            </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    <div class="modal fade" id="sRequestModal" tabindex="-1" aria-labelledby="sRequestModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="padding: 0;">
                    <div class="modal-body" style="padding: 0;">
                        <div class="row refs_popup">
                            <div class="col-md-4 popup_left">
                                <div class="popup_icon">
                                    <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                    <p style="font-size: 20px; font-weight: 500;"> Service Request </p>
                                </div>
                            </div> 
                            <div class="col-md-8 popup_right">
                                <div class="popup_close_btn">
                                    <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                </div>
                                <div class="container p-3"> 
                                    <h1 class="text-center"> Raise a Request </h1>
                                    <hr>
                                    <form role="form">
                                        <div class="form-group col-md-12 col-sm-12">
                                            <select name="serType" [ngModel]="sReq.type" (ngModelChange)="onTypeChange($event)" class="form-control p-2" style="width: 100%">
                                                <option value="0" disabled> Type </option>
                                                <option *ngFor="let x of srReqTypesSel" [ngValue]="x.id">{{x.text}} </option>
                                            </select>                                       
                                        </div>
                                        <div class="form-group col-md-12 col-sm-12">
                                            <textarea class="form-control col-md-12" (change)="changeSRDetail($event)" placeholder="Description"></textarea>
                                        </div>
                                        <div class="form-group col-md-12 col-sm-12">
                                            <input type="file" id="imageupload" class="form-control upload_box" name="images" (change)="onChange($event)">
                                        </div>
                                        <div class="submit_btn">
                                            <a class="btn popup_submit" data-dismiss="modal" (click)="submitSRequest()"> Submit </a>
                                        </div>    
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    
    <!---------------------------------- Service Screen ends here ----------------------------------------------------->
    <!----------------------------------- Referals Screen start ------------------------------------------------------>
    <div class="container-fluid" *ngIf="referalScreen == true" style="height: 80vh;">
        <div class="container">
            <div class="mb-4">
                <h2 class="greetings"> References </h2>
            </div>
            <div class="col-md-12" style="padding: 0px">
                <!-- <button class="btn raise_service mb-4" data-toggle="modal" data-target="#addRefModal" style="background-color: #F9E316; border: none; color: black; font-weight: 500;" > Add Referal </button> -->
            </div>
            <div *ngIf="user.email !== 'care@yourownroom.com'">
                <p>Something went wrong. Please try again after sometime.</p>
            </div>
            <div *ngIf="user.email === 'care@yourownroom.com'" class="refScreen_box">
                <div class="ref_box">
                    <div>
                        <h4> Name : <span style="font-weight: 500;">Ankit Anand </span> </h4>
                        <h4> Email : <span style="font-weight: 500;"> ankit.anand.20@gmail.com </span></h4>
                        <h4> Phone : <span style="font-weight: 500;"> 9234745253 </span> </h4>
                    </div>
                    <div>
                        <h4> Date : <span style="font-weight: 500;"> 12th April 2021 </span> </h4>
                        <h4> Refered For : <span style="font-weight: 500;"> E1, Kumar Picasso </span> </h4>
                        <h4> Refered On :  <span style="font-weight: 500;"> Tenant </span> </h4>
                    </div>  
                </div>
            </div>
            <div class="refScreen_box">
                <div class="ref_box">
                    <div>
                        <h4> Name : <span style="font-weight: 500;">Anushka Singh </span> </h4>
                        <h4> Email : <span style="font-weight: 500;"> anushkasingh.20@gmail.com </span></h4>
                        <h4> Phone : <span style="font-weight: 500;"> 9593335110 </span> </h4>
                    </div>
                    <div>
                        <h4> Date : <span style="font-weight: 500;"> 10th April 2021 </span> </h4>
                        <h4> Refered For : <span style="font-weight: 500;"> Jasmanium G1</span> </h4>
                        <h4> Refered On :  <span style="font-weight: 500;"> Tenant </span> </h4>
                    </div>  
                </div>
            </div>
        </div>
        <div class="modal fade" id="addRefModal" tabindex="-1" aria-labelledby="addRefModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header" style="padding: 0;">
                        <div class="modal-body" style="padding: 0;">
                            <div class="row refs_popup">
                                <div class="col-md-4 popup_left">
                                    <div class="popup_icon">
                                        <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                        <p style="font-size: 20px; font-weight: 500;"> Add Referals </p>
                                    </div>
                                </div>
                                <div class="col-md-8 popup_right">
                                    <div class="popup_close_btn">
                                        <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                                    </div>
                                    <form class="p-4">
                                        <div class="form-group col-md-12">
                                            <input class="form-control" name="name" placeholder="Name " type="text">
                                        </div>
                                        <div class="form-group col-md-12">
                                            <input class="form-control" name="email" placeholder="Email " type="text">
                                        </div>
                                        <div class="form-group col-md-12">
                                            <input class="form-control" name="phone" placeholder="Phone" type="text">
                                        </div>
                                        <div class="form-group col-md-12">
                                            <input class="form-control" name="property_name" placeholder="Property Name" type="text">
                                        </div>
                                        <div class="form-group col-md-12"> 
                                            <input type="radio" id="male" name="refType" value="Owner" class="mr-2">
                                            <label for="owner" class="mr-4" >Owner</label>
                                            <input type="radio" id="female" name="refType" value="tenant" class="mr-2">
                                            <label for="tenant" class="mr-4">Tenant</label>
                                        </div>
                                        <div class="col-md-12 d-flex justify-content-center">
                                            <button class="btn btn-primary mb-3" style="background-color: #3db44b; color: black; border: none;"> Submit </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!---------------------------------------- Referal Template ends here --------------------------------------------->
    <!--------------------------------------- Document Template starts here ------------------------------------------->
    <div class="container-fluid" *ngIf="documentScreen == true" style="height: 80vh">
        <div class="container">
                <h2 class="greetings"> Hey <span style="text-transform: capitalize;"> {{ tenantName }} </span> ! Let's look at the documents you have submitted to YourOwnROOM </h2>
        </div>
        <div class="container">
            <div>
                <div class="col-md-4 docCard p-4 " *ngFor="let doc of getDocsData">
                        <div style="display: flex; justify-content: space-between;">
                            <h4 style="text-transform: uppercase;font-size: 18px; font-weight: 500;"> {{ doc.type == 'rent' ? 'Agreement' : doc.type }}</h4>
                        </div> 
                        <hr>
                        <div style="display: flex; justify-content: space-between;">
                            <p [ngStyle]="{'color': doc.status == 0 ? '#F9E316' : doc.status == 1 ? 'coral' : '#4BB543'}" > {{ doc.status == 0 ?'Pending' : doc.status == 1?'Rejected' : doc.status == 10 ?'Confirmed': '' }}</p>
                            <fa-icon class="fa-lg" [ngStyle]="{'color' : doc.status == 0 ? '#F9E316' : doc.status == 1 ? 'coral' : '#4BB543'}" [icon]="doc.status == 0 ? faExclamationCircle  : doc.status == 1 ? faTimesCircle : faCheckCircle "></fa-icon>    
                        </div>
                        <a class="text-center" (click)="openDocs(doc.url)" style="cursor: pointer;"> View </a>
                </div>
            </div>
        </div>
    </div>
    <!------------------------------------------------- Document Template ends here ---------------------------------->    
    <!------------------------------------------------- Offers Screen  ---------------------------------->         
    <div class="container-fluid" *ngIf="offerScreen == true" style="height: 80vh; display: flex; justify-content: center; align-items: center;">
        <div class="container">
            <div class="mb-4">
                <h2 class="greetings text-center"> Offers coming soon! Stay connected with us. </h2>
            </div>
            
        </div>
    </div>
    <!-- <div class="container news_section" *ngIf="tenantPropCheck != 1">
        <div class="row mt-5" style="margin: 0;">
            <div class="col-md-12">
                <h2 class="home_sec_head">In News</h2>
            </div>
        </div>
    </div>
    <div class="container"  *ngIf="tenantPropCheck != 1">
      <div class="yor_news" id="news_carousal">
        <div class="news col-12 col-lg-3 col-md-4">
          <a href="https://yourstory.com/2017/02/yourownrooms-mantra-for-profitable-scaling/" target="_blank">
            <img src="assets/images/news/news_yourstory.png">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="http://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/" target="_blank">
            <img src="assets/images/news/news_full-Disrupt-logo.png">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="http://www.deccanherald.com/content/594969/yourownroom-helps-singles-find-their.html" target="_blank">
            <img src="assets/images/news/news_deccan.jpeg">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="https://thetechpanda.com/2017/10/04/startup-millennials-apartments/" target="_blank">
            <img src="assets/images/news/news_TheTechPanda.png">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="http://www.siliconindia.com/magazine/startup-of-the-year-special-october-2016/" target="_blank">
            <img src="assets/images/news/news_siliconindia.gif">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="http://www.indianweb2.com/2016/09/29/yourownroom/" target="_blank">
            <img src="assets/images/news/news_indianweb2.png">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="http://m.dailyhunt.in/news/india/english/yourstory-epaper-yourstory/this+startup+aims+to+address+the+demand+supply+gap+in+home+rentals+for+singles+in+india-newsid-58968547" target="_blank">
            <img src="assets/images/news/news_dailyhunt.png">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="http://www.propertyportalwatch.com/indian-property-portal-dedicated-finding-homes-singles-receives-seed-funding/" target="_blank">
            <img src="assets/images/news/news_propertyportal.png">
          </a>
        </div>
        <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
          <a href="http://epaper.prabhatkhabar.com/c/10229063" target="_blank">
            <img src="assets/images/news/news_prabhatkhabar.jpg">
          </a>
        </div>
      </div>
    </div> 
    <div class="container">
    <div class="scroll_indicator_wrapper">
      <img src="assets/images/left-arrow.svg" (click)="newsLeft()" class="scroll_indicator">
      <img src="assets/images/right-arrow.svg" (click)="newsRight()" class="scroll_indicator">
    </div>
  </div> -->
  <!------------------------------------ TEstimonials  ---------------------------------------------------->
    
</div>



  

